const util = {
    isNull : function (obj){
        if (obj == undefined){
            return true;
        }
        if (obj == null){
            return true;
        }
        if (obj == ""){
            return true;
        }
        return false;
    }
}
export default util;